const ɵ0 = () => import("./../module/index-default/index-default.module.ngfactory").then(mod => mod.IndexDefaultModuleNgFactory), ɵ1 = () => import("./../module/index-collection/index-collection-01/index-collection-01.module.ngfactory").then(mod => mod.IndexCollection01ModuleNgFactory), ɵ2 = () => import("./../module/index-collection/index-collection-02/index-collection-02.module.ngfactory").then(mod => mod.IndexCollection02ModuleNgFactory), ɵ3 = () => import("./../module/index-collection/index-collection-03/index-collection-03.module.ngfactory").then(mod => mod.IndexCollection03ModuleNgFactory), ɵ4 = () => import("./../module/index-search/index-search-01/index-search-01.module.ngfactory").then(mod => mod.IndexSearch01ModuleNgFactory), ɵ5 = () => import("./../module/index-search/index-search-02/index-search-02.module.ngfactory").then(mod => mod.IndexSearch02ModuleNgFactory), ɵ6 = () => import("./../module/index-subject/index-subject-01/index-subject-01.module.ngfactory").then(mod => mod.IndexSubject01ModuleNgFactory), ɵ7 = () => import("./../module/index-subject/index-subject-02/index-subject-02.module.ngfactory").then(mod => mod.IndexSubject02ModuleNgFactory), ɵ8 = () => import("./../module/index-subject/index-subject-03/index-subject-03.module.ngfactory").then(mod => mod.IndexSubject03ModuleNgFactory), ɵ9 = () => import("./../module/index-subject/index-subject-04/index-subject-04.module.ngfactory").then(mod => mod.IndexSubject04ModuleNgFactory), ɵ10 = () => import("./../module/index-subject/index-subject-05/index-subject-05.module.ngfactory").then(mod => mod.IndexSubject05ModuleNgFactory), ɵ11 = () => import("./../module/index-subject/index-subject-06/index-subject-06.module.ngfactory").then(mod => mod.IndexSubject06ModuleNgFactory), ɵ12 = () => import("./../module/index-subject/index-subject-07/index-subject-07.module.ngfactory").then(mod => mod.IndexSubject07ModuleNgFactory), ɵ13 = () => import("./../module/index-subject/index-subject-08/index-subject-08.module.ngfactory").then(mod => mod.IndexSubject08ModuleNgFactory), ɵ14 = () => import("./../module/index-subject/index-subject-09/index-subject-09.module.ngfactory").then(mod => mod.IndexSubject09ModuleNgFactory), ɵ15 = () => import("./../module/index-subject/index-subject-10/index-subject-10.module.ngfactory").then(mod => mod.IndexSubject10ModuleNgFactory), ɵ16 = () => import("./../module/index-quiz/index-quiz-01/index-quiz-01.module.ngfactory").then(mod => mod.IndexQuiz01ModuleNgFactory), ɵ17 = () => import("./../module/index-quiz/index-quiz-02/index-quiz-02.module.ngfactory").then(mod => mod.IndexQuiz02ModuleNgFactory), ɵ18 = () => import("./../module/index-article/index-article-01/index-article-01.module.ngfactory").then(mod => mod.IndexArticle01ModuleNgFactory), ɵ19 = () => import("./../module/index-article/index-article-02/index-article-02.module.ngfactory").then(mod => mod.IndexArticle02ModuleNgFactory), ɵ20 = () => import("./../module/index-banner/index-banner-02/index-banner-02.module.ngfactory").then(mod => mod.IndexBanner02ModuleNgFactory), ɵ21 = () => import("./../module/index-banner/index-banner-03/index-banner-03.module.ngfactory").then(mod => mod.IndexBanner03ModuleNgFactory), ɵ22 = () => import("./../module/index-banner/index-banner-04/index-banner-04.module.ngfactory").then(mod => mod.IndexBanner04ModuleNgFactory);
export const indexSectionWidgets = [
    {
        path: 'index-default',
        loadChildren: ɵ0
    },
    {
        path: 'index-collection-01',
        loadChildren: ɵ1
    },
    {
        path: 'index-collection-02',
        loadChildren: ɵ2
    },
    {
        path: 'index-collection-03',
        loadChildren: ɵ3
    },
    {
        path: 'index-search-01',
        loadChildren: ɵ4
    },
    {
        path: 'index-search-02',
        loadChildren: ɵ5
    },
    {
        path: 'index-subject-01',
        loadChildren: ɵ6
    },
    {
        path: 'index-subject-02',
        loadChildren: ɵ7
    },
    {
        path: 'index-subject-03',
        loadChildren: ɵ8
    },
    {
        path: 'index-subject-04',
        loadChildren: ɵ9
    },
    {
        path: 'index-subject-05',
        loadChildren: ɵ10
    },
    {
        path: 'index-subject-06',
        loadChildren: ɵ11
    },
    {
        path: 'index-subject-07',
        loadChildren: ɵ12
    },
    {
        path: 'index-subject-08',
        loadChildren: ɵ13
    },
    {
        path: 'index-subject-09',
        loadChildren: ɵ14
    },
    {
        path: 'index-subject-10',
        loadChildren: ɵ15
    },
    {
        path: 'index-quiz-01',
        loadChildren: ɵ16
    },
    {
        path: 'index-quiz-02',
        loadChildren: ɵ17
    },
    {
        path: 'index-article-01',
        loadChildren: ɵ18
    },
    {
        path: 'index-article-02',
        loadChildren: ɵ19
    },
    {
        path: 'index-banner-02',
        loadChildren: ɵ20
    },
    {
        path: 'index-banner-03',
        loadChildren: ɵ21
    },
    {
        path: 'index-banner-04',
        loadChildren: ɵ22
    },
];
export function indexSectionArrayToObj() {
    const result = {};
    for (const w of indexSectionWidgets) {
        result[w.path] = w.loadChildren;
    }
    return result;
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22 };
